import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/app");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
      } catch (e) {
        console.error("Auth failed", e);
      } finally {
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f0f11]">
      <div className="text-center">
        <div className="speed-bars h-10 mb-4 justify-center">
          <i /><i /><i />
        </div>
        <p className="font-heading text-[#8a8d91] uppercase tracking-widest text-sm">Starting your engine...</p>
      </div>
    </div>
  );
}
